import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function VisitorsPage(){return <ExtendedModulePage moduleKey="visitors"/>}
